import React from "react";
import { useParams } from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import { useState } from "react";
import { apiPath } from "../../utility/Constant";
import { useEffect } from "react";
import GlobalForm from "../../components/globalForm/GlobalForm";
import { updateData } from "../../hooks/update";

function CsrHighlightUniquepage() {
  const { CSRApi } = apiPath;
  const { id } = useParams();
  const [csrData, uloading] = useFetch(CSRApi, true);
  const [filteredData, setFilteredData] = useState({});

  useEffect(() => {
    const filtereddata = [...csrData]
      .filter((item) => item.slug === "highlight")
      .filter((item) => item._id === id)[0];
    setFilteredData(filtereddata);
  }, [csrData]);

  const { highlightTitle, highlightDescription, _id } = filteredData ?? {};

  const data = [
    {
      elementType: "textField",
      label: "Highlight Count",
      type: "text",
      name: "highlightTitle",
      defaultValue: highlightTitle,
      required: true,
    },
    {
      elementType: "textField",
      label: "Highlight Description",
      type: "text",
      name: "highlightDescription",
      defaultValue: highlightDescription,
      required: true,
    },
  ];

  const update = (data) => {
    updateData(`${CSRApi}/${id}`, data, true);
  };

  return <div>{_id && <GlobalForm data={data} update={update} />}</div>;
}

export default CsrHighlightUniquepage;
